'use client'

import Modal from '@/components/ui/Modal'
import { useUserStore } from '@/core/stores/user'
import Cookies from 'js-cookie'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import FailedfullInvite from './(pages)/profile/(with-container)/(sidebar-layout)/refer/FailedfullInvite'
import RegisterReferralCode from './(pages)/profile/(with-container)/(sidebar-layout)/refer/RegisterReferalCode'
import SuccessfullInvite from './(pages)/profile/(with-container)/(sidebar-layout)/refer/SuccessfullInvite'

export default function ReferralPopup() {
    const { affiliateLinkReferralCode, isGettingProfile } = useUserStore()

    const [open, setOpen] = useState(false)



    useEffect(() => {
        const hasClosedPopup = Cookies.get('referralPopupClosed')

        if (!affiliateLinkReferralCode && !isGettingProfile && !hasClosedPopup) {
            setOpen(true)
        }
    }, [isGettingProfile])

    const handleClose = () => {
        Cookies.set('referralPopupClosed', 'true', { expires: 365 })
        setOpen(false)
    }

    function handleRegisterPopUpShow(state: boolean) {
        setOpen(state)
    }

    const [showSuccess, setShowSuccess] = useState(false)
    const [showFailed, setShowFailed] = useState(false)
    const [error, setError] = useState<string | null>(null)

    return (
        <>
            <FailedfullInvite
                error={error}
                onTryAnother={() => {
                    setTimeout(() => {
                        handleRegisterPopUpShow(true)
                    }, 300)
                }}
                code='' isOpen={showFailed}
                onClose={() => { setShowFailed(false) }} />

            <SuccessfullInvite code='' isOpen={showSuccess} baseApi=''
                onClose={() => { setShowSuccess(false) }} />

            <Modal
                maxWidth='md:max-w-xl'
                show={open}
                identifier='referral-popup'
                onClose={handleClose}
            >
                <div className='p-4'>
                    <div className='flex items-center justify-center my-6'>
                        <Image
                            className='max-w-60'
                            width={600}
                            height={400}
                            alt=''
                            src={`${process.env.NEXT_PUBLIC_STORAGE_URL}avatar/d43812fe-0ac9-46b1-9d28-5c137b5e0071-planingo.png`}
                        />
                    </div>

                    <div>
                        <p className='text-lg font-semibold'>Do you have referral code?</p>
                        <p className='text-sm font-normal mt-2'>
                            Enter your referral code to unlock special prices and perks.
                        </p>
                    </div>

                    <div className='mt-6'>
                        <RegisterReferralCode
                            onError={(error) => {
                                setOpen(false)
                                setError(error)
                                setTimeout(() => {
                                    setShowFailed(true)
                                }, 300)
                            }}
                            onSuccess={() => {
                                handleClose()
                                setTimeout(() => {
                                    setShowSuccess(true)
                                }, 300)

                            }}
                        />

                    </div>
                </div>
            </Modal>
        </>
    )
}
